import XClose from '../../assets/images/icons/x-close-icon.svg?react'
import { useDeleteProductTagMutation } from '../../store/api/product'
import type { ProductTag } from '../../store/types/product'

type Props = {
  tags: ProductTag[]
  showAll: boolean
  toggleShowAll: () => void
}

function ProductCardTags({ tags, toggleShowAll, showAll }: Props): JSX.Element {
  const [deleteProductTag] = useDeleteProductTagMutation()

  const handleDeleteProductTag = (id: number) => async () => {
    await deleteProductTag(id)
  }

  return (
    <div className="flex flex-row flex-wrap">
      {(showAll ? tags : (tags ?? []).slice(0, 3)).map((productTag) => (
        <div
          className="border border-solid border-gray-300 rounded-md mr-2 mb-2"
          key={productTag.id}
        >
          <div className="flex flex-row items-center px-2 ">
            <span className="font-medium text-sm text-gray-700 pr-1">
              {productTag.tag.name}
            </span>
            <button
              type="button"
              onClick={handleDeleteProductTag(productTag.id)}
            >
              <XClose />
            </button>
          </div>
        </div>
      ))}
      {tags.length > 3 && (
        <button className="button mb-2" onClick={toggleShowAll}>
          <span className="inline-flex items-center gap-x-3">
            <span className="text-primary-700 text-xs font-medium">
              {!showAll ? `Show all tags ${`(${tags.length})`}` : 'Show less '}
            </span>
          </span>
        </button>
      )}
    </div>
  )
}

export default ProductCardTags
